import type { ComponentProps } from "react";

interface ArrowExternalProps extends ComponentProps<"svg"> {
  fill?: string;
}

const ArrowExternal = ({ fill = "#F55036", ...props }: ArrowExternalProps) => {
  return (
    <svg
      aria-label="arrow external"
      role="img"
      width="11"
      height="11"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_34_663)">
        <path
          d="M5.70078 1.80005H1.15078C0.957476 1.80005 0.800781 1.95674 0.800781 2.15005V9.85005C0.800781 10.0434 0.957476 10.2 1.15078 10.2H8.85078C9.04409 10.2 9.20078 10.0434 9.20078 9.85005V5.30005"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.75951 2.24011L4.30469 6.69493"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.71952 3.20009L7.79968 1.28025C7.60594 1.08651 7.74315 0.755249 8.01713 0.755249H9.71952C10.0095 0.755249 10.2445 0.990292 10.2445 1.28025V2.98263C10.2445 3.25661 9.91326 3.39383 9.71952 3.20009Z"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_34_663">
          <rect width="11" height="11" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArrowExternal;
